<ng-template>
  @if (logoUrl && (isBurgerMenuBpMatched$ | async) === false) {
    <img class="img-inline" [alt]="label" [src]="logoUrl" />
  }
  <span>{{ label }}</span>
</ng-template>
